const modules = {};

export default class ImportUtils {
  static async getSwiper() {
    if ('swiper' in modules) {
      return modules.swiper;
    }
    const swiper = (await import(/* webpackChunkName: "Swiper" */ 'swiper')).default;
    modules.swiper = swiper;
    return modules.swiper;
  }

  static async getStickySidebar() {
    if ('stickySidebar' in modules) {
      return modules.stickySidebar;
    }

    const stickySidebar = (await import('sticky-sidebar')).default;
    modules.stickySidebar = stickySidebar;
    return modules.stickySidebar;
  }
}
